// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const IconClose: React.FC = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 16 16"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            focusable="false"
            width="24"
            height="24"
            fill="currentColor"
        >
            <path d="M8 16A8 8 0 108 0a8 8 0 000 16zm3.06-10l-.532.531L9.06 8l1.47 1.469.53.531L10 11.06l-.531-.532L8 9.06l-1.469 1.47-.531.53L4.94 10l.532-.531L6.94 8 5.47 6.531 4.942 6 6 4.94l.531.532L8 6.94l1.469-1.47.531-.53L11.06 6z" />
        </svg>
    );
};

export default React.memo(IconClose);
